import Header from "../components/Header";
import Banner from "../components/Banner";
import ClientLogo from "../components/ClientLogo";
import About from "../components/About";
import Products from "../components/Products";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Popup from "../components/Popup";

const Home = () => {
  return (
    <>
      <Header />
      <Banner />
      <ClientLogo />
      <About />
      <Products />
      <Testimonials />
      <Contact />
      <Footer />
      <Popup />
    </>
  );
};

export default Home;
